/* eslint-disable import/no-extraneous-dependencies */
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { Amplify } from "@aws-amplify/core";
import App from "./app/app";
import ScrollToTop from "./app/ScrollToTop";
import Theme from "./styles/theme";
import RootProvider from "./context/root-provider";
import { PageHeaderProvider } from "./context/PageHeaderContext";
import awsconfig from "./aws-config";
import "./styles/main.scss";
import "./index.css";

// Set initial theme from localStorage before first render to avoid flash
const stored = localStorage.getItem("tapp-theme");
document.documentElement.setAttribute("data-theme", stored || "dark");

Amplify.configure(awsconfig);

const Main = () => (
  <RootProvider>
    <PageHeaderProvider>
      <ThemeProvider theme={Theme}>
        <Router>
          <ScrollToTop />
          <App />
        </Router>
      </ThemeProvider>
    </PageHeaderProvider>
  </RootProvider>
);

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<Main />);
